import React, { ReactNode } from 'react';
import { SwiperSlide } from 'swiper/react';
import { CarrouselWrapper, Section } from './SectionSimilars.styles';
import { Title } from '@/components/typography';
import { Container } from '@/components/container';
import CardProductVertical from '@/features/pacote/components/CardProductVertical/CardProductVertical';
import CarrouselFeatured from '@/components/carrousel/CarrouselFeatured';

export interface CarrouselPackagesProps {
  title?: string;
  className?: string;
  children?: ReactNode;
  similars: [PacoteType];
}

const SectionSimilars = ({
  title = 'Veja também os roteiros semelhantes',
  similars,
  children,
  ...props
}: CarrouselPackagesProps) => {
  return similars && similars.length ? (
    <Section>
      <Container>
        <Title as="h2" weight="black" size="2xl" color="secondary_500">
          {title}
        </Title>

        <CarrouselWrapper>
          <CarrouselFeatured slidesPerView={3} minHeight="40rem">
            {similars.map((pacote, index) => (
              <SwiperSlide key={`${pacote.id}-${index}`}>
                <CardProductVertical pacote={pacote} />
              </SwiperSlide>
            ))}
          </CarrouselFeatured>
        </CarrouselWrapper>
      </Container>
    </Section>
  ) : null;
};

export default SectionSimilars;
